import { render, staticRenderFns } from "./QRichEditor.vue?vue&type=template&id=495d2399&scoped=true&"
import script from "./QRichEditor.vue?vue&type=script&lang=js&"
export * from "./QRichEditor.vue?vue&type=script&lang=js&"
import style0 from "./QRichEditor.vue?vue&type=style&index=0&id=495d2399&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d2399",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
